import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';

var get = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mid) {
    var _ref2, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get('/moduleSession/' + mid);

          case 2:
            _ref2 = _context.sent;
            data = _ref2.data;
            return _context.abrupt('return', data);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function get(_x) {
    return _ref.apply(this, arguments);
  };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicantList from '~/components/mainPage/bookModuleSession/ApplicantList';
import UploadFilePanel from '~/components/mainPage/bookModuleSession/UploadFilePanel';
import AddApplicant from '~/components/mainPage/bookModuleSession/AddApplicant.vue';

import axios from '~/plugins/axios.js';
import domain from '~/plugins/domain.js';

export default {
  // name: "comboBook-module-session-page",
  components: {
    ApplicantList: ApplicantList,
    UploadFilePanel: UploadFilePanel,
    AddApplicant: AddApplicant
  },
  data: function data() {
    return {
      moduleSeatTaken: this.$store.state.currentModuleSession,
      msInfoJumKey: 'font-weight:bold;color:#777;font-size:15px',
      msInfoContent: 'font-weight:thin;color:#999;font-size:20px',
      companyBadge: 'margin:20px;padding:5px;'
      // moduleSessionName: this.$store.state.bookModuleSession.currentModuleSession.moduleName
    };
  },
  asyncData: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var store = _ref3.store,
          params = _ref3.params,
          error = _ref3.error;
      var moduleSession;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return get(params.mid);

            case 2:
              moduleSession = _context2.sent;

              console.log('\n\n ======= mainPage/_Mid/.vue params.mid ====== \n', params.mid, '\n ====================');
              console.log('\n\n ======= mainPage/_Mid/.vue Module Session====== \n', moduleSession, '\n ====================');
              store.commit('setModuleSession', moduleSession);
              return _context2.abrupt('return', { moduleSession: moduleSession });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function asyncData(_x2) {
      return _ref4.apply(this, arguments);
    }

    return asyncData;
  }(),
  head: function head() {
    return {
      title: 'comboBook this session'
    };
  },
  fetch: function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var store = _ref5.store,
          redirect = _ref5.redirect,
          context = _ref5.context;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (store.state.authUser) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return', redirect('/'));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function fetch(_x3) {
      return _ref6.apply(this, arguments);
    }

    return fetch;
  }(),
  mounted: function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (this.moduleSession.moduleName.match(/ssk/gi)) {
                alert('Please make sure applicant(s) has already attended IFWO/SIC!');
              } else if (!this.moduleSession.moduleName.match(/sic/gi)) {
                alert('Please make sure applicant(s) has already attended IFWO/SIC');
              }

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function mounted() {
      return _ref7.apply(this, arguments);
    }

    return mounted;
  }(),

  methods: {
    addApplicant: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(nricFin) {
        var newApplicant, userActorId, adminActorId, moduleSessionActorId, managerId, msStatusActorId, bookSuccessful, managers;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(nricFin === "")) {
                  _context5.next = 4;
                  break;
                }

                alert('Can not add empty applicant !!!');
                _context5.next = 34;
                break;

              case 4:
                _context5.next = 6;
                return axios.post('/users/nricFin', { nricFin: nricFin });

              case 6:
                newApplicant = _context5.sent.data;

                console.log('\n\n ====== new applicant nricFin ====== \n', nricFin, '\n ========');
                console.log('\n\n ====== new applicant ====== \n', newApplicant, '\n ========');

                if (!(newApplicant.isActivated !== 'User Not Found')) {
                  _context5.next = 33;
                  break;
                }

                // ================ comboBook this module ================
                userActorId = newApplicant.id;
                adminActorId = this.$store.state.authUser.id;
                moduleSessionActorId = this.$store.state.currentModuleSession.id;
                managerId = 'userMsManager' + userActorId; // item.id -> user.id

                msStatusActorId = 'msStatus' + moduleSessionActorId + userActorId;


                console.log(msStatusActorId);

                // const bookSuccessful = await axios.post('/userMsManager/bookModuleSession', {
                //   moduleName: this.moduleSession.moduleName,
                //   managerId,
                //   moduleSessionActorId,
                //   adminActorId
                // })
                //
                // console.log(bookSuccessful)

                _context5.next = 18;
                return axios.post('/userMsManager/bookModuleSession', {
                  moduleName: this.moduleSession.moduleName,
                  managerId: managerId,
                  moduleSessionActorId: moduleSessionActorId,
                  adminActorId: adminActorId
                });

              case 18:
                bookSuccessful = _context5.sent.data;

                if (!(newApplicant.hasOwnProperty('nricFin') && !bookSuccessful.hasOwnProperty('isActivated') && !bookSuccessful.hasOwnProperty('workForceCategory') && !bookSuccessful.hasOwnProperty('seats') && !bookSuccessful.hasOwnProperty('preReq') && !bookSuccessful.hasOwnProperty('dupBooking'))) {
                  _context5.next = 29;
                  break;
                }

                console.log('\n\n ======= _mid <|-- add new applicant successful ====== \n');

                this.$store.commit('addNewApplicantToApplicantList', newApplicant);
                _context5.next = 24;
                return axios.get('/userMsManager/' + moduleSessionActorId);

              case 24:
                managers = _context5.sent.data;

                this.$store.commit('setcurrentMsManagerList', managers);
                window.location.reload();
                _context5.next = 30;
                break;

              case 29:
                if (bookSuccessful.hasOwnProperty('isActivated')) {
                  alert(bookSuccessful['isActivated']);
                } else if (bookSuccessful.hasOwnProperty('dupBooking') || bookSuccessful.hasOwnProperty('dupError')) {
                  alert(bookSuccessful['dupBooking']);
                } else if (bookSuccessful.hasOwnProperty('seats')) {
                  alert(bookSuccessful['seats']);
                } else if (bookSuccessful.hasOwnProperty('workForceCategory')) {
                  alert(bookSuccessful['workForceCategory']);
                } else if (bookSuccessful.hasOwnProperty('preReq')) {
                  alert(bookSuccessful['preReq']);
                }

              case 30:
                console.log('\n\n ====== indiv this module ====== \n', bookSuccessful, '\n ========');
                _context5.next = 34;
                break;

              case 33:
                alert(newApplicant.isActivated);

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addApplicant(_x4) {
        return _ref8.apply(this, arguments);
      }

      return addApplicant;
    }(),


    // =================== CANCEL BOOKING FUNCTION ================
    cancelBooking: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref9) {
        var item = _ref9.item,
            key = _ref9.key;
        var userActorId, adminActorId, moduleSessionActorId, managerId, msStatusActorId, cancelInfo, managers, applicantList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('\n\n ======== argv from cancel booking btn ======\n', item, '\n', key, '\n ========');

                userActorId = item.id;
                adminActorId = this.$store.state.authUser.id;
                moduleSessionActorId = this.$store.state.currentModuleSession.id;
                managerId = 'userMsManager' + item.id; // item.id -> user.id

                msStatusActorId = 'msStatus' + moduleSessionActorId + userActorId;


                console.log('\n\n ======== argv from cancel booking new GEN ======\n', userActorId, '\n', adminActorId, '\n', moduleSessionActorId, '\n', managerId, '\n ==========');

                _context6.next = 9;
                return axios.post('/userMsManager/unBookModuleSession', { managerId: managerId, moduleSessionActorId: moduleSessionActorId, adminActorId: adminActorId, msStatusCode: 1 });

              case 9:
                cancelInfo = _context6.sent;
                _context6.next = 12;
                return axios.get('/userMsManager/' + moduleSessionActorId);

              case 12:
                managers = _context6.sent.data;
                _context6.next = 15;
                return this.getApplicantList(managers);

              case 15:
                applicantList = _context6.sent;


                this.$store.commit('setcurrentMsApplicantList', applicantList);
                this.$store.commit('setcurrentMsManagerList', managers);

                console.log('\n\n =========== cancel info =========\n', cancelInfo, '\n');

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function cancelBooking(_x5) {
        return _ref10.apply(this, arguments);
      }

      return cancelBooking;
    }(),


    // =========== Get the applicant list pending Uploadfile =============
    getApplicantList: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(managers) {
        var applicantList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, m, userActorId, msStatusId, msStatusCode, user, _user;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                applicantList = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 4;
                _iterator = _getIterator(managers);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context7.next = 28;
                  break;
                }

                m = _step.value;
                userActorId = m.userActorId;
                msStatusId = 'msStatus' + this.$store.state.currentModuleSession.id + userActorId;
                _context7.next = 12;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 12:
                msStatusCode = _context7.sent.data.msStatusCode;

                if (!(msStatusCode === 100)) {
                  _context7.next = 25;
                  break;
                }

                if (!(this.$store.state.authUser.flag === 'Admin')) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 17;
                return axios.get('/users/' + userActorId);

              case 17:
                user = _context7.sent.data;

                applicantList.push(user);
                _context7.next = 25;
                break;

              case 21:
                _context7.next = 23;
                return axios.get('/users/' + userActorId);

              case 23:
                _user = _context7.sent.data;

                _user.companyName === this.$store.state.authUser.companyName //match(new RegExp(this.$store.state.authUser.companyName))
                ? applicantList.push(_user) : console.log('not in same company');

              case 25:
                _iteratorNormalCompletion = true;
                _context7.next = 6;
                break;

              case 28:
                _context7.next = 34;
                break;

              case 30:
                _context7.prev = 30;
                _context7.t0 = _context7['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context7.t0;

              case 34:
                _context7.prev = 34;
                _context7.prev = 35;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 37:
                _context7.prev = 37;

                if (!_didIteratorError) {
                  _context7.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context7.finish(37);

              case 41:
                return _context7.finish(34);

              case 42:
                return _context7.abrupt('return', applicantList);

              case 43:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 30, 34, 42], [35,, 37, 41]]);
      }));

      function getApplicantList(_x6) {
        return _ref11.apply(this, arguments);
      }

      return getApplicantList;
    }(),
    getReloadedData: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                window.location.reload();

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getReloadedData() {
        return _ref12.apply(this, arguments);
      }

      return getReloadedData;
    }(),
    getSeatTakenCount: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(seatTakenUpdate) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.moduleSeatTaken = seatTakenUpdate;

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getSeatTakenCount(_x7) {
        return _ref13.apply(this, arguments);
      }

      return getSeatTakenCount;
    }()
  }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/mainPage/_mid.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/mainPage/_mid.vue
// module chunks = 8